import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo_64.png";
import "./DesktopPublicNavbar.css";

const DesktopPublicNavbar = ({ isAuthenticated }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const main = document.querySelector(".app-main-layout");

    const handleScroll = () => {
      setScrolled(main.scrollTop > 65);
    };

    main.addEventListener("scroll", handleScroll);
    return () => main.removeEventListener("scroll", handleScroll);
  }, []);

  if (isAuthenticated) return null;

  return (
    <nav
      className={`desktop-public-navbar ${scrolled ? "desktop-public-navbar--scrolled" : ""}`}
    >
      <div className="desktop-public-navbar__container">
        <div className="desktop-public-navbar__logo">
          <Link to="/" className="desktop-public-navbar__logo-link">
            <img src={logo} alt="Katch Logo" className="logo__img" />
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default DesktopPublicNavbar;
